<template>
	<div class="row centered">
		<AppTable ref="receipts-table"
			v-if="userStore.currBusinessId"
			:fetch-function="administrationStore.getFilteredApiscontrinoReceipts"
			:filters="filters"
			:table-headings="tableHeadings"
			:title="getString('apiscontrino_receipts')"
			:total-items="administrationStore.businessApiscontrinoReceiptsTotal || 0"
			:items="administrationStore.businessApiscontrinoReceipts || []"
			initial-sort-field="date"
			allow-download
			@export="exportReceipts"
			@failed-fetch="details=>{$emit('failed-fetch', details)}" >

			<template v-slot:ade_id="{item}">
				<div class="row centered">
					<p class="payment-intent" :class="{clickable: !!item.order_id}" @click="goToOrder(item.order_id)">{{ item.ade_id }}</p>
				</div>
			</template>

		</AppTable>
	</div>
</template>

<script>
import AppTable from "@/shared/components/AppTable.vue";
import {useUserStore, useAdministrationStore, useOrdersStore} from "@/console-new/stores";
import {useLanguageStore, useScriptStore, useCurrencyStore, useNotificationStore} from "@/shared/stores";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppTableButtonGroup from "@/shared/components/AppTableButtonGroup.vue";
import {doubleFigure, formatDateOnly, formatDateTimeWithSeconds} from "@/shared/helpers/dates";
import {exportToFile} from "@/shared/helpers/excel";

export default {
	setup() {
		const userStore = useUserStore();
		const administrationStore = useAdministrationStore();
		const languageStore = useLanguageStore();
		const ordersStore = useOrdersStore();
		const scriptStore = useScriptStore();
		const currencyStore = useCurrencyStore();
		const notificationStore = useNotificationStore();
		return {userStore, administrationStore, getString: languageStore.getString, ordersStore, scriptStore, currencyStore, showNotification: notificationStore.showNotification};
	},
	name: "ApiscontrinoReceiptsTable",
	emits: ["failed-fetch"],
	components: {AppTableButtonGroup, AppButtonIcon, AppTable},
	data() {
		return {
			filters: [
				{
					type: "date",
					key: 'date',
					tableName: 'businesses_receipts',
					text: this.getString('date'),
					finalValue: '',
					active: false
				},
				{
					type: "price",
					key: "total",
					text: this.getString('amount'),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			tableHeadings: [
				{
					text: this.getString('receipt_number'),
					cols: 1,
					sortable: false,
					fieldName: 'ade_id',
					slotName: 'ade_id',
				},
				{
					text: this.getString('date'),
					cols: 1,
					sortable: true,
					fieldName: 'date',
					formatter: function(val) {
						return doubleFigure(val.getDate()) + '-' + doubleFigure(val.getMonth() + 1) + '-' + val.getFullYear();
					}
				},
				{
					text: this.getString('amount'),
					cols: 1,
					sortable: true,
					fieldName: 'total',
					formatter: 'currency'
				},
				{
					text: this.getString('type'),
					cols: 1,
					fieldName: 'type',
					formatter: payment_type => payment_type ? this.getString('payment_type_' + payment_type) : '-',
				},
			],
			
		}
	},
	computed: {
	},
	methods: {
		goToOrder(orderId) {
			if(orderId) {
				this.ordersStore.search = "id:"+orderId;
				this.ordersStore.showCompleted = true;
				this.ordersStore.filterCounter = true;
				this.ordersStore.filterDelivery = true;
				this.ordersStore.filterTakeaway = true;
				this.ordersStore.filterRooms = true;
				this.ordersStore.refreshOrders();
				this.$router.push("/ops/orders");
			}
		},
		exportReceipts(expExtension) {
			let header = [];
			this.tableHeadings.forEach(heading => {
				if(heading.text) {
					header.push(heading.text);
				}
			});

			let today = new Date().toLocaleString();
			let businessNameNorm = this.userStore.currBusiness.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
			let fileName = businessNameNorm+"_"+this.getString('apiscontrino_receipts').toLowerCase()+"_"+today.replace(", ", "_");
			exportToFile({
				columns: [
					{ header: header[0], key: 'ade_id' },
					{ header: header[1], value: r => formatDateTimeWithSeconds(r.date, false) },
					{ header: header[2], value: r => this.currencyStore.dbToActualValue(r.total), type: 'number', numberFormat: '#,##0.00' },
					{ header: header[3], value: r => this.getString('payment_type_' + r.type) },
				],
				rows: this.administrationStore.businessApiscontrinoReceipts,
				fileName,
				sheetName: this.getString("apiscontrino_receipts"),
				format: expExtension,
				onEmpty: () => this.showNotification('table-no-data'),
				onError: () => this.showNotification('generic-fail'),
			});
		}
	},
	watch: {
		'userStore.currBusinessId': {
			handler(newVal, oldVal) {
				if(newVal && newVal !== oldVal) {
					if(this.$refs['receipts-table']) {
						this.$refs['receipts-table'].fetchData();
					}
				}
			},
		},
	}
}
</script>


<style lang="scss" scoped>
a:after {
	content: none;
}

.no-download {
	font-size: 12px;
}

.payment-intent {
	text-align: left;
	width: 100%;
	font-size: 12px;

	&.clickable {
		cursor: pointer;
		color: var(--color-primary);
		text-decoration: underline;
	}
}
</style>
